/**
 * @file Form group component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from './Label';
import Input from './Input';
import Textarea from './Textarea';

const propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'text',
    'password',
    'email',
    'url',
    'search',
    'number',
    'hidden',
    'textarea',
    'button',
  ]),
  label: PropTypes.node,
  labelNote: PropTypes.string,
  labelTip: PropTypes.string,
  labelTipPlace: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  labelSrOnly: PropTypes.bool,
  labelType: PropTypes.oneOf(['standard', 'expanded']),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  note: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(['md', 'sm']),
  required: PropTypes.bool,
  labelProps: PropTypes.object,
};

const FormGroup = ({
  id,
  type = 'text',
  className,
  label,
  labelNote,
  labelTip,
  labelSrOnly,
  labelType,
  inputClassName,
  placeholder,
  inputRef,
  note,
  size,
  labelTipPlace,
  required,
  labelProps,
  ...props
}) => {
  const classes = classNames({
    'form-group': true,
    [`form-group-${size}`]: !!size,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {label && (
        <Label
          id={id}
          label={label}
          labelNote={labelNote}
          labelTip={labelTip}
          labelSrOnly={labelSrOnly}
          labelTipPlace={labelTipPlace}
          size={size}
          labelType={labelType}
          required={required}
          {...labelProps}
        />
      )}

      {type === 'textarea' ? (
        <Textarea
          id={id}
          className={inputClassName}
          placeholder={placeholder}
          inputRef={inputRef}
          size={size}
          required={required}
          {...props}
        />
      ) : (
        <Input
          id={id}
          type={type}
          className={inputClassName}
          placeholder={placeholder}
          inputRef={inputRef}
          size={size}
          required={required}
          {...props}
        />
      )}
      {note}
    </div>
  );
};

FormGroup.propTypes = propTypes;

export default FormGroup;
